<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
    step: number;
    totalSteps: number;
}>();

const steps = [
    { number: 1, labelKey: 'setup.steps.account', subKey: 'setup.steps.accountSub' },
    { number: 2, labelKey: 'setup.steps.yourPage', subKey: 'setup.steps.yourPageSub' },
    { number: 3, labelKey: 'setup.steps.payment', subKey: 'setup.steps.paymentSub' },
    { number: 4, labelKey: 'setup.steps.firstPlan', subKey: 'setup.steps.firstPlanSub' },
    { number: 5, labelKey: 'setup.steps.goLive', subKey: 'setup.steps.goLiveSub' },
];

function stepStatus(n: number): 'done' | 'active' | 'todo' {
    if (n < props.step) return 'done';
    if (n === props.step) return 'active';
    return 'todo';
}
</script>

<template>
    <nav class="flex flex-col">
        <div v-for="(s, i) in steps" :key="s.number" class="flex" style="gap: 12px">
            <div class="flex flex-col items-center">
                <span
                    class="flex size-[22px] shrink-0 items-center justify-center rounded-full text-[11px] font-semibold"
                    :style="{
                        background: stepStatus(s.number) === 'done' ? 'var(--nv-success)'
                            : stepStatus(s.number) === 'active' ? 'var(--nv-indigo)'
                            : 'var(--card)',
                        border: stepStatus(s.number) === 'todo' ? '1px solid var(--nv-border-strong)' : '1px solid transparent',
                        color: stepStatus(s.number) === 'todo' ? 'var(--muted-foreground)' : '#FFFFFF',
                    }"
                >
                    <template v-if="stepStatus(s.number) === 'done'">&#10003;</template>
                    <template v-else>{{ s.number }}</template>
                </span>
                <span v-if="i < steps.length - 1" class="w-px flex-1 bg-border" style="min-height: 26px" />
            </div>
            <div style="padding-top: 2px; padding-bottom: 18px">
                <div
                    class="text-[13px]"
                    :style="{
                        fontWeight: stepStatus(s.number) === 'active' ? 600 : 500,
                        color: stepStatus(s.number) === 'todo' ? 'var(--muted-foreground)' : 'var(--foreground)',
                    }"
                >{{ t(s.labelKey) }}</div>
                <div class="mt-0.5 text-[11px] text-muted-foreground">
                    {{ stepStatus(s.number) === 'done' ? 'Completed' : stepStatus(s.number) === 'active' ? 'In progress' : t(s.subKey) }}
                </div>
            </div>
        </div>
    </nav>
</template>
